import { MainConteiner } from './Container.styled';

export const Container = ({children}) => {
  return <MainConteiner>{children}</MainConteiner>;
};
